import { VinoDataOffer } from "../../types/vino-data-types";
import { currencyFormatter } from "../../utils/currency-formatter";
import { isSingleVinoDataWineSKU } from "./sku";

export const priceDescriptionFromVinoDataOffer = ({
  sku,
  packPrice,
}: VinoDataOffer): string => {
  const packPriceFormatted = currencyFormatter(packPrice);

  if (isSingleVinoDataWineSKU(sku) || sku?.packSize === 1) {
    return `${packPriceFormatted} / ${sku?.packSize}PK`;
  }

  const unitPrice = packPrice / sku?.packSize;
  const unitPriceFormatted = currencyFormatter(unitPrice);

  return `${sku?.packSize}PK - ${unitPriceFormatted} / BTL`;
};
